import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function BeneficiarStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Beneficiarul este persoana fizica"
          description="Dezactiveaza pentru SRL sau alta societate comerciala"
          checked={!!data.beneficiarPF}
          onChange={() => update("beneficiarPF")(!data.beneficiarPF)}
        />
      </div>

      {data.beneficiarPF ? (
        <>
          <InputField label="Nume complet" value={data.beneficiarNume} onChange={update("beneficiarNume")} placeholder="ex: Ionescu Maria" required error={errors.beneficiarNume} />
          <InputField label="Adresa de domiciliu" value={data.beneficiarAdresa} onChange={update("beneficiarAdresa")} placeholder="ex: Str. Exemplu nr. 2, Bucuresti" required error={errors.beneficiarAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.beneficiarCNP} onChange={update("beneficiarCNP")} placeholder="ex: 1234567890123" half error={errors.beneficiarCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.beneficiarCI} onChange={update("beneficiarCI")} placeholder="ex: MZ 654321" half error={errors.beneficiarCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      ) : (
        <>
          <InputField label="Denumire societate" value={data.beneficiarDenumire} onChange={update("beneficiarDenumire")} placeholder="ex: SC Exemplu SRL" required error={errors.beneficiarDenumire} />
          <InputField label="CUI" value={data.beneficiarCUI} onChange={update("beneficiarCUI")} placeholder="ex: RO12345678" required half error={errors.beneficiarCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.beneficiarRegCom} onChange={update("beneficiarRegCom")} placeholder="ex: J40/1234/2020" half error={errors.beneficiarRegCom} />
          <InputField label="Sediu social" value={data.beneficiarSediu} onChange={update("beneficiarSediu")} placeholder="ex: Str. Exemplu nr. 2, Bucuresti" required error={errors.beneficiarSediu} />
          <InputField label="Reprezentant legal" value={data.beneficiarReprezentant} onChange={update("beneficiarReprezentant")} placeholder="ex: Ionescu Maria" required error={errors.beneficiarReprezentant} />
        </>
      )}
    </div>
  );
}
